import { BooleanParam, DecodedValueMap, StringParam, withDefault } from 'use-query-params';
import ArrayParam from '../utils/ArrayParam';
import NumberParam from '../utils/NumberParam';

export const companySearchFilterParams = {
    categorySlugs: ArrayParam,
    placeId: withDefault(StringParam, undefined),
    mainCategorySlugs: ArrayParam,
};

export const companySearchViewParams = {
    offset: withDefault(NumberParam, undefined),
    searched: withDefault(BooleanParam, undefined),
};

const companySearchParams = {
    ...companySearchFilterParams,
    ...companySearchViewParams,
};

export default companySearchParams;

export type CompanySearchParams = Partial<DecodedValueMap<typeof companySearchParams>>;
